import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/i18n';
import numberFormats from '@/i18n/formats/number';
import dateTimeFormats from '@/i18n/formats/dates';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: localStorage.getItem('cat4mroLanguage'),
  fallbackLocale: 'en-US',
  messages,
  numberFormats,
  dateTimeFormats,
});

export default ({ app }) => {
  // Set i18n instance on app
  Vue.set(app, 'i18n', i18n);
};



// WEBPACK FOOTER //
// ./src/plugins/vue-i18n.js